import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { InicioComponent } from './inicio.component';
import { CommonModule } from '@angular/common';

@NgModule({
  declarations: [
    InicioComponent
  ],
  imports: [
    TranslateModule,
    CommonModule
  ],
  exports: [
    InicioComponent
  ]
})

export class InicioModule { }
